/* Newsletter → Klaviyo
   Suscribe el email a la lista de Klaviyo (API pública de cliente, solo necesita la clave pública)
   y además envía el formulario de Shopify para que quede como cliente suscrito. Sin JS o sin
   Klaviyo configurado, el formulario funciona como siempre (solo Shopify). */
(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.newsletter__form')) return;
    var key = form.dataset.klaviyoKey;
    var list = form.dataset.klaviyoList;
    var input = form.querySelector('input[type="email"]');
    if (!key || !list || !input || !window.fetch) return;

    event.preventDefault();
    var email = input.value.trim();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    var klaviyo = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Web · bloque newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  locale: document.documentElement.lang || undefined,
                  properties: { 'Página de alta': window.location.pathname }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      })
    });

    // Copia en Shopify (cliente con consentimiento de marketing); si falla no bloquea el alta en Klaviyo
    var shopify = fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).catch(function () {});

    klaviyo
      .then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        return shopify;
      })
      .then(function () {
        var field = form.querySelector('.newsletter__field');
        if (field) {
          field.classList.add('newsletter__field--done');
          field.innerHTML = '<p class="newsletter__message newsletter__message--success" role="status"></p>';
          field.firstChild.textContent = form.dataset.success || '✓';
        }
      })
      .catch(function () {
        // Si Klaviyo no responde, envío normal del formulario de Shopify
        if (button) button.disabled = false;
        form.submit();
      });
  });
})();
